/**
 * The quick reactions a user can put on one of the agent's messages, in picker
 * order. The picker's + opens every other emoji; these are the ones a tap away.
 *
 * Deliberately short, and separate from the server's classifier catalog, which
 * is what the agent picks from: these are what the user picks from. ❌ is a
 * reaction like the rest — "no, not that" — rather than a way to close the
 * picker, and the agent reads it as such.
 */
export const userReactionEmojis = ["👍", "👎", "❤️", "❌"] as const;

export type UserReactionEmoji = (typeof userReactionEmojis)[number];

/**
 * Rollout gate for the user's reactions on the agent's replies.
 *
 * Shared because the server and both clients check it and must check the same
 * string: an unrecognised gate name reads false, so a typo on one side would
 * hide the picker or refuse every reaction without erroring anywhere.
 */
export const USER_REACTIONS_GATE = "user-reactions";
